import {SingleScoDataMap} from "scorm/common/SingleScoDataMap";

export function SingleSco2004Data(){

    const lmsRelevant = [
        "cmi.location",
        "cmi.completion_status",
        "cmi.success_status",
        "cmi.exit",
        "cmi.score.raw",
        "cmi.progress_measure"
    ];

    // lms values
    let scoData = new SingleScoDataMap([
        ["cmi.completion_threshold", "0.8"],
        ["cmi.credit", "credit"],
        ["cmi.location", "index"],
        ["cmi.completion_status", ""],
        ["cmi.success_status", ""],
        ["cmi.exit", ""],
        ["cmi.score.min", "0"],
        ["cmi.score.max", "1"],
        ["cmi.score.raw", ""],
        ["cmi.session_time", "00:00:00"],
        ["cmi.suspend_data", ""],
        ["cmi.progress_measure", ""]

    ]);

    function isNotAttempted(){
        return scoData.get("cmi.completion_status") === "not attempted";
    }

    return {
        set: scoData.set,
        get: scoData.get,
        isValid: scoData.isValid,
        isNotAttempted: isNotAttempted,
        isCourseManagedValue: (dataModelId) => {
            return dataModelId === "cmi.completion_threshold"
                || dataModelId ==="cmi.credit";
        },
        checkSuspendDataSize: () => {
            const suspendData = scoData.get("cmi.suspend_data");
            return suspendData.length < 64000;
        },
        forEachLmsRelevantValue: function( callback ){
            lmsRelevant.forEach( ( dataModelId ) => {

                const value = scoData.get( dataModelId );
                if( !value ) {
                    return;
                }

                if (dataModelId === "cmi.completion_status" && isNotAttempted()) {
                    return;
                }

                callback( value, dataModelId );
            });
        }
    };
}
